import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-auth-kit'
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js'
import './index.css';

import App from './App';
const root = ReactDOM.createRoot(document.getElementById('root-clarit'));
root.render(
  <AuthProvider
    authType={"cookie"}
    authName={"aiseo_cookie"}
    cookieDomain={window.location.hostname}
    cookieSecure={true}
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AuthProvider>
);
